import { createContext, useState, useEffect } from 'react'

export const ActivityContext = createContext()

export const ActivityProvider = ({ children, sessionId }) => {
  const [timelineData, setTimelineData] = useState([])
  const [observablePatterns, setObservablePatterns] = useState({
    copyPaste: { label: 'Copy-paste:', count: 0 },
    reviseEdit: { label: 'Revise and edit:', count: 0 },
    events: { label: 'Event:', count: 0 },
    testRuns: { label: 'Test-Case Run:', count: 0 },
    interfereOptions: [
      { action: 'No action needed', enabled: true },
      { action: 'Suggest Reflection and Feedback', enabled: true },
      { action: 'Send Alert', enabled: true },
      { action: 'Ask Self-Explanation', enabled: false },
      { action: 'Send Conceptual Quiz', enabled: false },
      { action: 'Flag for TA Follow-up', enabled: false }
    ],
    confidence: [
      { label: 'Confused', value: 78, color: '#9B4DCA' },
      { label: 'Confusled', value: 78, color: '#D8BFD8' }
    ],
    sentiment: [
      { label: 'Frustrated', value: 66, color: '#FF6B6B' },
      { label: 'Flustered', value: 66, color: '#FFB6B6' },
      { label: 'Calm', value: 55, color: '#4169E1' }
    ]
  })
  const [latestConversations, setLatestConversations] = useState([
    { type: 'knowledge', message: "don't know the basic knowledge", count: 28 },
    { type: 'discussion', message: 'unproductive discussion (non relevant topic being discussed)', count: 18 },
    { type: 'syntax', message: 'asking about list indexing syntax', count: 12 },
    { type: 'debugging', message: 'struggling with nested for loop logic', count: 9 },
    { type: 'debugging', message: 'struggling with lists', count: 9 },
  ])
  const [confidenceSentiment, setConfidenceSentiment] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    // When backend is connected, fetch activity data here
    // For now, using dummy data set above
    setLoading(false)
  }, [sessionId])

  const value = {
    timelineData,
    observablePatterns,
    latestConversations,
    confidenceSentiment,
    loading,
  }

  return (
    <ActivityContext.Provider value={value}>
      {children}
    </ActivityContext.Provider>
  )
}